import { all } from 'redux-saga/effects';

import bankAccountSaga from './bankAccountSaga';
import settingsSaga from './settingsSaga';
import userSaga from './userSaga';
import commonSaga from './commonSaga';
import personSaga from './personSaga';
import applicationSaga from './applicationSaga';
import plaidSaga from './plaidSaga';
import metalStreamSaga from './metalStreamSaga';
import affiliateSaga from './affiliateSaga';
import documentsSaga from './documentsSaga';
import fundingSaga from './fundingSaga';
import custodiansSaga from './custodiansSaga';
import iraFundingSaga from './iraFundingSaga';
import agreementSaga from './agreementSaga';
import salesAssisteSaga from './salesAssistedSaga';
import fundingSourceSaga from './fundingSourceSaga';
import employmentSaga from './employmentSaga';
import identificationVerificationSaga from './identifcationVerificationSaga';
import crmEventsSaga from './crmEventsSaga';

export default function* rootSaga() {
  yield all([
    settingsSaga(),
    bankAccountSaga(),
    userSaga(),
    commonSaga(),
    personSaga(),
    applicationSaga(),
    plaidSaga(),
    metalStreamSaga(),
    affiliateSaga(),
    documentsSaga(),
    fundingSaga(),
    iraFundingSaga(),
    custodiansSaga(),
    agreementSaga(),
    salesAssisteSaga(),
    fundingSourceSaga(),
    employmentSaga(),
    identificationVerificationSaga(),
    crmEventsSaga(),
  ]);
}
